import * as React from "react";
import type { SVGProps } from "react";
const SvgFunpark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#funpark_svg__a)">
      <path d="M21 22c-.55 0-1-.45-1-1v-7h-.06c-.46 4.05-3.72 7-7.94 7s-7.48-2.95-7.94-7H4v7c0 .55-.45 1-1 1s-1-.45-1-1v-8c0-.55.45-1 1-1h2c.55 0 1 .45 1 1 0 3.42 2.58 6 6 6s6-2.58 6-6c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1" />
      <path d="M13.71 17.27c-.08 0-.15 0-.23-.03-.65-.15-1.37-.55-1.83-1.02l-5.79-5.8c-.48-.48-.79-1.09-.91-1.77-.09-.54.27-1.06.81-1.16s1.06.27 1.16.81c.05.28.17.51.36.7l5.78 5.8c.2.2.6.42.88.49.54.13.87.67.75 1.2-.11.46-.52.77-.97.77z" />
      <path d="M11.05 14.89c-.19 0-.38-.05-.55-.17a1.01 1.01 0 0 1-.28-1.39l1.89-2.84c.3-.44.89-.58 1.35-.3l.12.07c.22.13.41.05.48 0 .07-.04.24-.17.24-.42V7.48a1 1 0 0 1 .38-.78c.24-.19.55-.26.85-.19l1.65.38 1.11-1.11a.996.996 0 1 1 1.41 1.41l-1.5 1.5c-.24.24-.6.34-.93.27l-.96-.22v1.1c0 .91-.47 1.71-1.26 2.16a2.4 2.4 0 0 1-1.73.27l-1.44 2.16c-.19.29-.51.45-.83.45zM12.5 7.5H11c-.11 0-.21-.02-.32-.05l-1.5-.5a1 1 0 0 1-.63-1.27c.17-.52.74-.81 1.26-.63l1.35.45h1.34c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M8.55 12.43c-.21 0-.42-.06-.59-.2-.44-.33-.54-.95-.21-1.4l2.03-2.74c.29-.39.82-.52 1.25-.3l1.89.95c.49.25.69.85.45 1.34-.25.49-.85.69-1.34.45l-1.14-.57-1.53 2.07c-.2.27-.5.41-.8.41zM14.37 6.84c-1.2 0-2.18-.98-2.18-2.18v-.47c0-1.2.98-2.18 2.18-2.18s2.18.98 2.18 2.18v.47c0 1.2-.98 2.18-2.18 2.18m0-2.84c-.1 0-.18.08-.18.18v.47c0 .2.37.2.37 0v-.47c0-.1-.08-.18-.18-.18z" />
    </g>
    <defs>
      <clipPath id="funpark_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFunpark;
